import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FamiliaequipoService } from '@/app/services/familiaequipo.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-crear-familiaequipo',
    templateUrl: './crear-familiaequipo.component.html',
    styleUrls: ['./crear-familiaequipo.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrearFamiliaequipoComponent {
  private spinner = inject(NgxSpinnerService);

  //Model
  familiaRQ = {
    descripcion: null,
    valor: null,
    activo: null,
  };

  //bandera global para cerrar el modal
  hasFinished: boolean = false;

  constructor(
    private familiaEquipoService: FamiliaequipoService,
    private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<CrearFamiliaequipoComponent>,
  ){
  }

  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas crear una nueva familia?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.crearFamilia();
        }
      });
    }
  }

  crearFamilia(){
    this.spinner.show();

    //Pendiente: asignar creao por desde token
    //this.UsuarioRQ.creadoPor = 'TO-DO';

    this.familiaEquipoService.insertFamilia(this.familiaRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Usuario registrado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();

        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado la familia. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }

}
